/**
 * Please inlcude...
 * - Test key (all caps)
 * - Test name (as it appears in TNL)
 * - Jira ticket to clean up the test after it runs
 */
const TESTS = {
    HOUSERULESV2UPDATE: 'HouseRulesV2Update', // https://jira.expedia.biz/browse/VCHK-11570
    HA_BOT_PROPERTYDETAILS_WEB_V1: 'HA_BOT_PropertyDetails_Web_v1',
    EG_BOT_VRBO_PDP_VAP_WEB_V1: 'EG_BOT_Vrbo_PDP_VAP_Web_V1',
    HA_BOT_PROPERTYDETAILSVALAUNCH_V2: 'HA_BOT_PropertyDetailsVALaunch_v2',
    HA_BOT_Recommendations_V1: 'HA_BOT_Recommendations_V1',
    HA_BOT_WEB_BEDMAPSPRICERULES: 'HA_BOT_Web_BedMapsPriceRules',
    HA_PDP_BIZMETRICS: 'ha_pdp_bizmetrics', // https://jira.expedia.biz/browse/VRBOSHOP-1843
    HA_GDPR_BANNER: 'ha_gdpr_banner',
    HA_IDA_LOGIN_TO_SAVE_TRIPBOARD: 'HA_IDA_LOGIN_TO_SAVE_TRIPBOARD',
    HA_IDA_PDP_GOOGLEONETAP: 'HA_IDA_PDP_GOOGLEONETAP',
    HA_IDA_V3_LOGIN_TEST: 'HA_IDA_V3_LOGIN_TEST',
    HA_INQUIRY_FORM_REDUNDANCIES_REMOVED: 'HA_Inquiry_Form_Redundancies_Removed',
    HA_PDP_PROPERTY_DESCRIPTION_FALLBACK: 'ha_pdp_property_description_fallback', // https://jira.expedia.biz/browse/VRBOSHOP-1892
    HA_PDP_VIRTUAL_TOUR_VIEWER: 'ha_pdp_virtual_tour_viewer',
    HA_VIRTUAL_TOUR_VIEWER_PDP_MOBILE: 'ha_virtual_tour_viewer_pdp_mobile',
    HA_PULSE_TRIPBOARD_GRAPHQL_THROTTLE: 'ha_pulse_tripboard_graphql_throttle',
    HA_PULSE_TRIPBOARD_NEW_MODAL_TEST: 'ha_pulse_tripboard_new_modal_test',
    HA_PULSE_SAVE_BUTTON_UPDATES: 'ha_pulse_save_button_updates', // https://jira.expedia.biz/browse/FRIENDS-3972
    HA_PDP_MWEB_PERF_INSIGHTS: 'ha_pdp_mweb_perf_insights', // https://jira.expedia.biz/browse/VRBOSHOP-1842
    HA_REACT_PRICE_DETAILS_: 'HA_REACT_PRICE_DETAILS_.*',
    PCSLPSDATAEXPERIMENT: 'pcsLpsDataExperiment',
    HA_PDP_REVIEWS_ON_DEMAND_TRANSLATION: 'ha_pdp_reviews_on_demand_translation',
    HA_PDP_RANKED_BADGES: 'ha_pdp_ranked_badges',
    HA_GX_PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    HA_GX_POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    REMOVE_PARTNER_NAME_AND_LOGO_FROM_PDP: 'remove_partner_name_and_logo_from_PDP',
    INLINE_PDP_VIRTUAL_TOUR: 'Inline_PDP_Virtual_Tour',
    HA_TYPEAHEAD_LID_SEARCH: 'HA_TYPEAHEAD_LID_SEARCH',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display_v2',
    MESO_VRBO_DISPLAY_ADS: 'MESO_Vrbo_display_ads',
    HA_PDP_RECO_NEW_TAB: 'HA_PDP_RECO_NEW_TAB', // https://jira.expedia.biz/browse/VRBOSHOP-1844
    VRBO_AFFIRM_NO_PREQUAL: 'Vrbo_Affirm_noPrequal',
    HA_IDA_PDP_LOGIN_TO_BOOK: 'HA_IDA_PDP_LOGIN_TO_BOOK',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY',
    HA_PTA_SEARCHBOX_ADDGUESTPICKERONPDP: 'HA_PTA_SEARCHBOX_addGuestPickerOnPDP',
    HA_PDP_VIRTUAL_TOUR_HELPFULNESS: 'HA_PDP_virtual_tour_helpfulness',
    HA_VT_NEW_FLOOR_NAV_MODAL: 'HA_VT_New_Floor_Nav_Modal',
    HA_VT_DIRECT_NAVIGATION: 'HA_VT_Direct_Navigation',
    VRBO_SERP_PDP_COVID_BANNER: 'vrbo_serp_pdp_covid_banner',
    VRBO_WEB_SIMPLE_RIGHT_RAIL_DISPLAY: 'vrbo_web_simple_right_rail_display', // https://jira.expedia.biz/browse/VRBOSHOP-1845
    VRBO_WEB_PDP_SPACES: 'vrbo_web_PDP_spaces', // https://jira.expedia.biz/browse/VRBOSHOP-1969
    HA_PTA_SEARCHFORM_DATES_NUMBER_OF_NIGHTS_SUMMARY:
        'HA_PTA_SEARCHFORM_datesnumberOfNightsSummary',
    VRBO_PDP_R2D2_QUERY: 'vrbo_pdp_r2d2_query',
    VRBO_PDP_R2D2_PLANB: 'vrbo_pdp_r2d2_planB',
    HA_PDP_FRAUD_PREVENTION_MSG_THROTTLE: 'ha_pdp_fraud_prevention_msg_throttle',
    HA_PDP_FRAUD_PREVENTION_MSG: 'ha_pdp_fraud_prevention_msg',
    VRBO_WEB_GLOBAL_MESSAGING_BANNER: 'vrbo_web_global_messaging_banner',
    HA_TRAVELER_HEADER_TRAY_MOBILE_APP: 'HA_TRAVELER_HEADER_TRAY_MOBILE_APP',
    VRBO_WEB_GLOBAL_MESSAGING_ALERT: 'vrbo_web_global_messaging_alert',
    VRBO_PRICEDETAILS_PAYMENTSCHEDULE: 'vrbo_PriceDetails_PaymentSchedule',
    VRBO_PDP_MOBILE_PRICETRANSPARENCY: 'vrbo_pdp_mobile_pricetransparency', // https://jira.expedia.biz/browse/COSS-173
    VRBO_PDP_MOBILE_PRICETRANSPARENCY_TEST2: 'vrbo_pdp_mobile_pricetransparency_test2', // https://jira.expedia.biz/browse/COSS-222
    HA_PTA_SEARCHBOX_ADD_AGE_OF_CHILDREN: 'HA_PTA_SEARCHBOX_addAgeOfChildren',
    HA_PTA_SEARCHBOX_HINT_TEXT_CHOOSING_DATES: 'HA_PTA_SEARCHBOX_hintTextChoosingDates',
    VRBO_LANDING_ARIA_ROLES_ON_SEARCHFORM: 'VRBO_LANDING_ARIArolesOnSearchForm',
    VRBO_LANDING_COLOUR_CONTRAST_ON_SEARCHFORM: 'VRBO_LANDING_colourContrastOnSearchForm',
    VRBO_LANDING_EXPANDED_SEARCHFORM_ON_PDP: 'VRBO_LANDING_expandedSearchFormOnPDP',
    VRBO_LANDING_SCALE_HINTTEXT_WHEN_CHOOSING_DATES: 'VRBO_LANDING_scale_HintTextWhenChoosingDates', // https://jira.expedia.biz/browse/SHCMP-2203
    VRBO_LANDING_SCALE_LAUNCH_SEARCH_FROM_GUESTPICKER:
        'VRBO_LANDING_scale_launchSearchFromGuestPicker',
    VRBO_LANDING_COLLAPSED_PDP_SF_CTA: 'VRBO_LANDING_collpased_PDP_SF_CTA', // https://jira.expedia.biz/browse/SHCMP-2164
    VRBO_LANDING_DESTINATIONLESS_ERROR_ON_SEARCHFORM:
        'VRBO_LANDING_DestinationlessErrorOnSearchForm', // https://jira.expedia.biz/browse/SHCMP-2137
    VRBO_LANDING_SEARCHFORM_DATEPICKER_DAY_OF_WEEK: 'VRBO_LANDING_searchFormDatepickerDayOfWeek', // https://jira.expedia.biz/browse/SHCMP-2238
    VRBO_LANDING_SEARCHFORM_DATE_FORMAT: 'VRBO_LANDING_searchFormDateFormat', // https://jira.expedia.biz/browse/SHCMP-2195
    VRBO_PDP_REVIEW_HIGHLIGHTS_V1: 'vrbo_pdp_review_highlights_v1',
    VRBO_PDP_LINE_ITEMS_DISCOUNT: 'vrbo_pdp_line_items_discount',
    VRBO_TOI_CATEGORIES: 'VRBO_TOI_CATEGORIES',
    VRBO_RECO_PDP_DESTINO_RECOMMENDATIONS: 'vrbo_Reco_PDP_Destino_Recommendations', // 40803
    VRBO_RECO_PDP_SAVE_BUTTON: 'Vrbo_reco_pdp_save_button',
    VRBO_PDP_REMOVE_OWNER_CAROUSEL: 'Vrbo_pdp_remove_owner_carousel',
    HA_PREMIERPARTNER_PROFILE: 'ha_premierpartner_profile', // Host Profile test
    VRBO_LANDING_REMOVE_URGENCY_MESSAGING: 'VRBO_LANDING_PDPEntryRemoveUrgencyMessaging', // 39725
    VRBO_WEB_PDP_SUMMARY: 'vrbo_web_PDP_summary', // https://jira.expedia.biz/browse/VRBOSHOP-2172
    VRBO_LANDING_PROPERTY_HERO_IMAGE_SELECTION: 'Vrbo_landing_propertyheroimageselection', // 39320 | https://jira.expedia.biz/browse/VGT-9108
    VRBO_PDP_WEB_INQUIRY_THROTTLE: 'vrbo_pdp_web_inquiry_throttle', // https://jira.expedia.biz/browse/VRBOSHOP-2245
    VRBO_LANDING_MORE_PROPERTIES_NOTIFICATION: 'VRBO_LANDING_PDPEntryMorePropertiesNotification' // 40565 | https://jira.expedia.biz/browse/VGT-9274
};

const EVALUATE = Object.values(TESTS);
const EVALUATE_AND_LOG = [];

module.exports = {
    EVALUATE,
    EVALUATE_AND_LOG,
    ...TESTS
};
